"use client";

import { getPrescriptions } from "@/api/saleor/services";
import { isStringTrue } from "@/apiUtils/commonUtils";
import { sessionQueryParams } from "@/apiUtils/constants";
import { Product, TranslationData, VariantItemPdp, PairEyewearTopsContent } from "@/common/lib/types";
import useWindowSearchParams, { useUpdateWindowSearchParams } from "@/hooks/useWindowSearchParams";
import { useGlobalStore } from "@/store/store";
import React, { FC, ReactElement, useCallback, useEffect, useState } from "react";
import LCPModal from "./LCPModal";

interface LensConfiguratorWrapperProps {
  locale: string;
  product: Product;
  source?: string;
  sourceId?: string;
  hitIndex?: number;
  queryID?: string;
  variant?: VariantItemPdp;
  translations: TranslationData;
  children: ReactElement<any, any>;
  toastToggle: (active: boolean) => void;
  lensConfiguratorImageURL: string;
  pairEyewearTopsContent?: PairEyewearTopsContent | null;
}

const LensConfiguratorWrapper: FC<LensConfiguratorWrapperProps> = ({
  locale,
  source,
  product,
  variant,
  sourceId,
  children,
  hitIndex,
  queryID,
  toastToggle,
  translations,
  lensConfiguratorImageURL,
  pairEyewearTopsContent,
}) => {
  const searchParams = useWindowSearchParams();
  const updateSearchParam = useUpdateWindowSearchParams();
  const { user, hasPrescriptions, setHasPrescription } = useGlobalStore();

  const [isFetchingPrescriptions, setIsFetchingPrescriptions] = useState(true);
  const [open, setOpen] = useState(
    isStringTrue(searchParams.get(sessionQueryParams.LENSE_SELECTOR)),
  );

  const handleToggleModal = () => {
    updateSearchParam([{ key: sessionQueryParams.LENSE_SELECTOR, value: undefined }], true);
    setOpen(!open);
  };

  const handleFetchUserPreference = useCallback(async () => {
    try {
      if (hasPrescriptions !== undefined) return;
      if (!user || !user.email || !user.name) return;

      const prescriptions = await getPrescriptions(1);
      setHasPrescription(prescriptions?.edges?.length > 0);
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetchingPrescriptions(false);
    }
  }, [user?.email, user?.name]);

  useEffect(() => {
    handleFetchUserPreference();
  }, [user?.email, user?.name]);

  console.log("isFetchingPrescriptions", {
    variant,
    hasPrescriptions,
    isFetchingPrescriptions,
  });

  return (
    <>
      {React.cloneElement(children, { onClick: handleToggleModal })}
      {open && (
        <LCPModal
          isOpen={open}
          locale={locale}
          source={source}
          product={product}
          variant={variant}
          sourceId={sourceId}
          hitIndex={hitIndex}
          queryID={queryID}
          toastToggle={toastToggle}
          translations={translations}
          onCloseLensConfigurator={handleToggleModal}
          isFetchingPrescriptions={isFetchingPrescriptions}
          lensConfiguratorImageURL={lensConfiguratorImageURL}
          pairEyewearTopsContent={pairEyewearTopsContent}
        />
      )}
    </>
  );
};

export default LensConfiguratorWrapper;
